export function PulseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M5.99984 5.02639L9.99984 14.3597L12.4394 8.66732H15.3332V7.33398H11.5602L9.99984 10.9749L5.99984 1.6416L3.56024 7.33398H0.666504V8.66732H4.43944L5.99984 5.02639Z"
        fill="currentColor"
      />
    </svg>
  );
}
